import { Row, Select } from "antd";
import { useEffect, useMemo } from "react";
import { usePermissions } from "../../../../../lib/hooks/usePermissions";
import { Print1098 } from "../../../../Account/components/View/User/PaymentHistory/components/Print1098";
import { PrintHistoryBtn } from "../../../../Account/components/View/User/PaymentHistory/components/PrintHistoryBtn";
import dayjs from "../../../../../configs/dayjs";

type FilterProps = {
  contractGeneralData: any;
  years: number[] | undefined;
  value: number | undefined;
  isLoading: boolean;
  setYear: React.Dispatch<React.SetStateAction<number | undefined>>;
};

export const Filter = ({
  contractGeneralData,
  years,
  value,
  isLoading,
  setYear,
}: FilterProps) => {
  const items: { label: string; value: number }[] = useMemo(() => {
    return (
      years?.map((year) => ({ label: year.toString(), value: year })) || []
    );
  }, [years]);

  const { hasAccessByController } = usePermissions(
    "ExternalUsersReportGeneration",
  );

  const onSelectYear = (value: number) => {
    setYear(value);
  };

  useEffect(() => {
    if (value) {
      setYear(value);
    } else if (years && years.length > 0) {
      setYear(years[years.length - 1]);
    } else if (years && years.length === 0) {
      setYear(dayjs().year());
    }
  }, [years, setYear, value]);

  return (
    <Row className="align-center w-100 mt-3 justify-space-between year-selector">
      <Row style={{ width: "30%" }}>
        <Select
          className="year-picker"
          options={items}
          value={value}
          onChange={onSelectYear}
          loading={isLoading}
        />
      </Row>
      <Row className="justify-end print-reports-section">
        <PrintHistoryBtn
          range={[dayjs().year(value || 0), dayjs().year(value || 0)]}
          accountNumber={contractGeneralData.accountNumber}
          type="link"
          disabled={!value}
        />
        {hasAccessByController("Report1098") && contractGeneralData.isBuyer && (
          <Print1098
            accountNumber={contractGeneralData.accountNumber}
            taxInfo={{
              beginningDate: contractGeneralData.beginningDate,
              isBuyer: contractGeneralData.isBuyer,
            }}
            type="link"
            text="1098"
            disabled={!value}
            customClassName="ml-0 print-1098-btn"
          />
        )}
      </Row>
    </Row>
  );
};
